export const getPostAverageRating = (state, postId) => state.postRatings[postId]?.averageRating;

export const getPostTotalRatings = (state, postId) => state.postRatings[postId]?.totalRatings;
